import React from "react";
import { ROUTE } from "../misc";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
    // ProviderInfoPage,
    SearchPage,
    ProviderCompareSelectPage,
    OverviewPage,
    ProviderComparePage,
    FAQPage,
    AboutPage,
    ProviderInfoPage
} from "../DynamicPage";
import { ReactBlockPage } from "../../Components/ReactBlockPage";
import { LoadingIndicator } from "../../Components/LoadingIndicator";
import { useShapefileData } from "../../Components/hooks";
import { ShapefileContext } from "../../Components/Context";

export const AboutPageContainer: React.FC<{}> = () => {
    return (
        <ReactBlockPage>
            <AboutPage />
        </ReactBlockPage>
    );
};

export const FAQPageContainer: React.FC<{}> = () => {
    return (
        <ReactBlockPage>
            <FAQPage />
        </ReactBlockPage>
    );
};

export const OverviewPageContainer: React.FC<{}> = () => {
    return (
        <ReactBlockPage>
            <OverviewPage />
        </ReactBlockPage>
    );
};

export const SearchPageContainer: React.FC<{}> = () => {
    const { scheme: schemeShapefile } = useShapefileData();

    return (
        <ReactBlockPage>
            {!schemeShapefile ? (
                <LoadingIndicator />
            ) : (
                <ShapefileContext.Provider value={{ scheme: schemeShapefile }}>
                    <SearchPage />
                </ShapefileContext.Provider>
            )}
        </ReactBlockPage>
    );
};

export const ProviderInfoPageContainer: React.FC<{}> = () => {
    const { scheme: schemeShapefile } = useShapefileData();

    if (!schemeShapefile)
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <LoadingIndicator />
                    </div>
                </div>
            </div>
        );

    return (
        <ShapefileContext.Provider value={{ scheme: schemeShapefile }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <ProviderInfoPage />
                    </div>
                </div>
            </div>
        </ShapefileContext.Provider>
    );
    // return (
    //     <div className="container-fluid">
    //         <div className="row">
    //             <div className="col-12">
    //                 <ProviderInfoPage />
    //             </div>
    //         </div>
    //     </div>
    // );
};

export const ProviderComparePageContainer: React.FC<{}> = () => {
    const { scheme: schemeShapefile } = useShapefileData();

    if (!schemeShapefile)
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <LoadingIndicator />
                    </div>
                </div>
            </div>
        );

    return (
        <ShapefileContext.Provider value={{ scheme: schemeShapefile }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <ProviderComparePage />
                    </div>
                </div>
            </div>
        </ShapefileContext.Provider>
    );
};

export const ProviderCompareSelectPageContainer: React.FC<{}> = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <ProviderCompareSelectPage />
                </div>
            </div>
        </div>
    );
};

export const ExplorerPageContainer: React.FC<{
    page: "search" | "providerInfo" | "providerSelectToCompare" | "providerCompare";
}> = ({ page }) => {
    if (page == null) return null;

    if (page === "search") return <SearchPageContainer />;

    if (page === "providerInfo") return <ProviderInfoPageContainer />;

    if (page === "providerCompare") return <ProviderComparePageContainer />;

    if (page === "providerSelectToCompare") return <ProviderCompareSelectPageContainer />;

    return null;
};

export const DynamicPageRouter: React.FC<{}> = () => {
    // const location = useLocation();
    // const content = useMemo(()=>{}, [location.])
    return (
        <Router>
            <Switch>
                {/* <Route path={ROUTE.FAQ} exact component={FAQPageContainer} />
                <Route path={ROUTE.HOME} exact component={OverviewPageContainer} /> */}
                <Route path={ROUTE.SEARCH_PAGE} exact={true} component={SearchPageContainer} />
                <Route path={ROUTE.PROVIDER_INFO} exact component={ProviderInfoPageContainer} />
                <Route path={ROUTE.PROVIDER_SELECT_TO_COMPARE} exact component={ProviderCompareSelectPageContainer} />
                <Route path={ROUTE.PROVIDER_COMPARE} exact component={ProviderComparePageContainer} />
            </Switch>
        </Router>
    );
};
